import { render } from "./About.vue?vue&type=template&id=7c8d2120"
const script = {}
script.render = render

export default script